// extracted by mini-css-extract-plugin
export default {"videoContainer":"responsiveStyles_videoContainer__z5lmX","videoContainerInner":"responsiveStyles_videoContainerInner__qQ4oM"};